export const ENV = process.env.REACT_APP_ENV;
export const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL;
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;
export const DOCUMENTS_URL = process.env.REACT_APP_DOCUMENTS_URL;
export const SERVER = process.env.REACT_APP_BE_SERVER;
export const WEBSOCKET = process.env.REACT_APP_BE_WEBSOCKET;
export const HOST = process.env.REACT_APP_HOST;

export const ENV_DEV: string = 'dev';
export const ENV_TEST: string = 'test';
export const ENV_PROD: string = 'prod';
